'use client'
// =============================================================================
// module-prefs.store — modules et agents que L'USAGER a désactivés pour lui-même.
// Source : GET /api/me/modules (base de données, donc suit l'usager d'un appareil à
// l'autre). Tant que la lecture n'a pas abouti, tout reste visible : on ne cache rien
// sur un doute. Écriture optimiste, annulée si le serveur refuse.
// =============================================================================

import { create } from 'zustand'
import { normalizeDisabled, toggled } from '../src/lib/module-catalog'

interface ModulePrefsState {
  disabled: string[]
  loaded: boolean
  error: string | null
  load: () => Promise<void>
  toggle: (key: string) => Promise<void>
}

export const useModulePrefs = create<ModulePrefsState>((set, get) => ({
  disabled: [],
  loaded: false,
  error: null,

  async load() {
    if (get().loaded) return
    try {
      const res = await fetch('/api/me/modules', { cache: 'no-store' })
      if (!res.ok) throw new Error(String(res.status))
      const body = await res.json()
      set({ disabled: normalizeDisabled(body.disabled), loaded: true, error: null })
    } catch {
      set({ error: 'Préférences indisponibles : tout reste affiché.' })
    }
  },

  async toggle(key) {
    const before = get().disabled
    const next = toggled(before, key)
    if (next.join() === before.join()) return
    set({ disabled: next, error: null })
    try {
      const res = await fetch('/api/me/modules', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ disabled: next }),
      })
      if (!res.ok) throw new Error(String(res.status))
    } catch {
      set({ disabled: before, error: 'Changement non enregistré — réessayez.' })
    }
  },
}))
